//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Images",
  props: ["bdrm", "data"]
};
